
import React, { FC } from 'react';

import {
    Card,
    Row,
    Spacer,
    Title,
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import {
    Button,
    Dropdown,
    Info,
    Input,
    Link
} from '@components/2-molecules';

import { STATE } from '@lib/constants';
import * as utils from '@lib/utils';


import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { useBusiness } from '@lib/hooks/useBusiness';
import { useBusinessType } from '@lib/hooks/useBusinessType';
import { useCountry } from '@lib/hooks/useCountry';

import Sandwich from '@assets/icons/sandwich';
import {
    DateInput,
    PageHeader,
    IconButton
} from '@components/2-molecules';

import * as WebBrowser from 'expo-web-browser';


import { ForwardedPageProps } from '@lib/constants';
import { WidgetWelcomeAndBusinessCreate } from '@components/3-organisms';
import { logout } from '@lib/service';


const BusinessCreate: FC<ForwardedPageProps> = ({ navigation, data = {}, onDone, ...props }) => {

    const [business, setBusiness] = useBusiness({ operation: 'POST', state: STATE.CANCEL, });

    const _onDone = utils.reloadApp;
    onDone = onDone || _onDone;
    utils.onStateChange(business , STATE.DONE, onDone);

    const payPalPaymentLink = `https://www.paypal.com/paypalme`;
    const venmoPaymentLink = `https://account.venmo.com/settings/profile`;
    
    const createBusiness = (): void => { setBusiness({ ...business, operation: 'POST', state: STATE.READY, message: 'Updating business ...' }) };

    const updateData = (data: any): void => setBusiness((business: any) => ({...business, data: { ...business.data, ...data } }));

    
    const [businessTypes,] = useBusinessType();
    const [countries,] = useCountry();

    return (
        <AppTemplate hooks={[business]}>
            <Spacer h={2} /> 

            <WidgetWelcomeAndBusinessCreate />
            <Spacer h={1} />

            <Card>
                <Input
                    required 
                    label={"Business name"}
                    defaultValue={business?.data?.name}
                    onChange={(value: any) => { updateData({ name: value }) }}
                />
                <Spacer h={.3} />
                <Info>Enter your name if you don't have a business name. This will appear on your financial documents.</Info>
                <Spacer h={1.3} />

                <Dropdown 
                    required
                    label={"Business type"}
                    defaultValue={business?.data?.businessType}
                    data={businessTypes?.data}
                    onChange={(value: any) => { updateData({ businessTypeId: value?.id, businessType: value }) }}
                />
                <Spacer h={1.3} />

                <Input
                    label='Description'
                    multiline
                    defaultValue={business?.data?.description}
                    onChange={(value: any) => { updateData({ description: value }) }} />
                <Spacer h={1.3} />

                <DateInput 
                    required
                    label={"Last day of fiscal year"}
                    dateFormat={"MMMM dd"}
                    defaultValue={business?.data?.financialDate}
                    onChange={(value: any) => { updateData({ financialDate: value }) }}
                />
                <Spacer h={1.3} />

                <Input
                    label={"Phone"}
                    defaultValue={business?.data?.phone}
                    onChange={(value: any) => { updateData({ phone: value }) }}
                />
            </Card>
            <Spacer h={1} />

            <Card>

                <Input 
                    label={"Address"}
                    defaultValue={business?.data?.addressLine1}
                    onChange={(value: any) => { updateData({ addressLine1: value }) }} />
                <Spacer h={1.3} />

                <Input 
                    label={"City"}
                    defaultValue={business?.data?.addressLine2}
                    onChange={(value: any) => { updateData({ addressLine2: value }) }} />
                <Spacer h={1.3} />

                <Dropdown
                    required
                    label={"Country"}
                    defaultValue={business?.data?.country}
                    data={countries?.data}
                    onChange={(value: any) => { updateData({ countryId: value?.id, counry: value }) }}
                />
                <Spacer h={1.3} />

            </Card>
            <Spacer h={1} />

            <Card>
                <Input
                    label='Default document footnote'
                    multiline
                    placeholder={'The note will appear on your documents as a footnote. It\'s an ideal place to communicate payments and all other type of instrusctions to the customer. You can change it when you are creating a document.'}
                    defaultValue={business?.data?.defaultNoteToReceiver}
                    onChange={(value: any) => { updateData({ defaultNoteToReceiver: value }) }} />
                <Spacer h={1} />

                <Row justification={'flex-start'}>
                    {/* PayPay button */}
                    <Link uri={payPalPaymentLink}>PayPal</Link>
                    <Spacer w={1} />

                    {/* Venmo button */}
                    <Link uri={venmoPaymentLink}>Venmo</Link>
                </Row>

            </Card>
            <Spacer h={3} />

            <Button onPress={createBusiness}>CREATE</Button>
            <Spacer h={1} />

            <Button inset bg={'transparent'} color={"#CC0808"} onPress={logout}>LOGOUT</Button>
            <Spacer h={1} />

            <Spacer h={2} />
        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(BusinessCreate);